import React, { useState, useCallback } from 'react';

import ReactDiffViewer from 'react-diff-viewer';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';

const ModalDiff = ({ oldValue, newValue, currentTag, onSave = () => {}, ...props }) => {
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [newVersion, setNewVersion] = useState('');

  const handleNewVersionChange = useCallback(e => {
    setNewVersion(e.target.value.toUpperCase().replace(' ', '_'));
  }, []);

  const handleSaveClick = useCallback(async () => {
    setSaving(true);
    try {
      await onSave(newVersion);
    } catch ({ response }) {
      setError(response);
    } finally {
      setSaving(false);
    }
  }, [onSave, newVersion]);

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="w-75 mw-100"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Review the changes you applied</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReactDiffViewer
          oldValue={oldValue}
          newValue={newValue}
          splitView={true}
          hideLineNumbers={true}
          showDiffOnly={true}
        />
        {!!error && (
          <Alert variant="danger" className={'mt-4'}>
            {error.status === 400 && error.data && error.data.config ? (
              <ul>
                {error.data.config.map(message => (
                  <li>{message}</li>
                ))}
              </ul>
            ) : (
              'We got an unexpected error'
            )}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex w-100 align-items-center">
          <div className="text-nowrap mr-3">
            Current version name: <strong>{currentTag}</strong>
          </div>

          <Form.Control
            type="text"
            placeholder="New version name"
            value={newVersion}
            className="mr-3 col-sm-2"
            onChange={handleNewVersionChange}
          />

          <div className="w-100">&nbsp;</div>

          <Button onClick={props.onHide} variant="outline-danger" className="text-nowrap mr-3">
            Cancel
          </Button>
          <Button
            variant="primary"
            className="text-nowrap"
            disabled={!newVersion || saving}
            onClick={handleSaveClick}
          >
            {!!saving && <Spinner animation="border" variant="light" size="sm" />}
            {!saving && <>Save new version</>}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDiff;
